import type { CategoryModel } from 'src/types/category';

import { useState, useEffect, useCallback } from 'react';

import { getCategories, updateCategory } from 'src/api/category.api';

import { toast } from 'src/components/snackbar';

// Assume there's a category API function

interface UseCategoriesProps {
  initialData?: CategoryModel[];
}

export function useCategories({ initialData = [] }: UseCategoriesProps = {}) {
  const [data, setData] = useState<CategoryModel[]>(initialData);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const fetchCategories = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const categories = await getCategories();

      setData(categories);
    } catch (err) {
      console.error('Error fetching categories:', err);
      setError(err instanceof Error ? err : new Error('Error al cargar categorías'));
      setData([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCategories();
  }, [fetchCategories]);

  const updateCategoryItem = useCallback(
    async (category: CategoryModel) => {
      console.log(category);
      try {
        setLoading(true);
        setError(null);

        await updateCategory(category.id, category);

        toast.success('Categoría actualizada correctamente');

        // Refresh categories after update
        await fetchCategories();

        return true;
      } catch (err) {
        console.error('Error updating category:', err);
        toast.error('Error al actualizar la categoría');
        setError(err instanceof Error ? err : new Error('Error al actualizar categoría'));
        return false;
      } finally {
        setLoading(false);
      }
    },
    [fetchCategories]
  );

  return {
    data,
    loading,
    error,
    refetch: fetchCategories,
    updateCategory: updateCategoryItem,
  };
}
